import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";

export const fetchShipping = createAsyncThunk(
    'shipping/fetch',
    async ({docId, onResolve}, thunkAPI) => {

        const handleResolve = (args) => onResolve && onResolve(args)

        return new Promise(async (resolve, reject) => {
            const refs = thunkAPI.getState().shippingListRef.ref;

            if (docId in refs) {
                handleResolve(refs[docId]);
                resolve({});
            } else {

                try {

                    const docSnap = await firestore.collection(`/shipping_orders/${docId}/Shippings_c`).get();

                    const result = docSnap.docs.map(doc => doc.data());

                    resolve({
                        [docId]: result
                    });

                    handleResolve(result);

                } catch (e) {

                    // console.log(e)
                    reject(e)
                    handleResolve([])

                }

            }

        })


    }
)

const shippingListSlice = createSlice({
    name: 'shipping_list',
    initialState: {
        ref: {}
    },
    extraReducers: builder => {
        builder.addCase(fetchShipping.fulfilled, (state, action) => {
            state.ref = {...state.ref, ...action.payload}
        })
    }
})

export default shippingListSlice.reducer;

export const selectShippingList = state => state.shippingListRef